module.exports = __webpack_public_path__ + "static/media/arrow.f9031462.svg";